import { useState } from 'react';
import { createOrdenCompra } from '../../helpers/api_helper';

const useCreateOrdenCompra = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const createOrdenCompraHook = async (data) => {
        setLoading(true);
        setError(null);
        try {
            const response = await createOrdenCompra(data);
            return response;
        } catch (err) {
            const errorMessage = `Failed to create orden compra: ${err.message || 'Unknown error'}`;
            setError(errorMessage);
            throw new Error(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return { createOrdenCompra: createOrdenCompraHook, loading, error };
};

export default useCreateOrdenCompra;